import React from 'react';

import Badge from 'ff/debrief/common/components/Badge';

const SharedFlightBadge: React.FC = () => {
    return (
        <Badge
            label={'Shared by me'}
            margin="4px 0 0"
            color="light-gray"
            icon="shared"
        />
    );
};

export default SharedFlightBadge;
